import { render, staticRenderFns } from "./WorkFaqDetail.vue?vue&type=template&id=23f89a07&scoped=true&"
import script from "./WorkFaqDetail.vue?vue&type=script&lang=js&"
export * from "./WorkFaqDetail.vue?vue&type=script&lang=js&"
import style0 from "./WorkFaqDetail.vue?vue&type=style&index=0&id=23f89a07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f89a07",
  null
  
)

export default component.exports